import React from "react";
import styled, { withTheme } from "styled-components/macro";

import {
  AppBar as MuiAppBar,
  Grid,
  Hidden,
  IconButton as MuiIconButton,
  ListItem as MuiListItem,
  ListItemText as MuiListItemText,
  Toolbar,
  Box,
} from "@material-ui/core";

import { Menu as MenuIcon } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../constants";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)}px;
  padding-right: ${(props) => props.theme.spacing(2)}px;
`;

const List = styled(Box)`
  display: flex;
  justify-content: end;
  margin-right: 12px;
  gap: 10px;
`;

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.sidebar.header.color};
  }
`;

const AppBarComponent = ({ onDrawerToggle }) => (
  <React.Fragment>
    <AppBar position="sticky" elevation={0}>
      <Toolbar>
        <Grid container alignItems="center">
          <Hidden mdUp>
            <Grid item>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Grid>
          </Hidden>

          <Grid item xs>
            <List>
              <ListItem
                button
                component="a"
                href="https://ccbwqportal.org/annual-report/2025/key-takeaways"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center" gap={0.5}>
                      Annual Reports{" "}
                      <OpenInNewIcon
                        fontSize="small"
                        style={{ marginLeft: 4 }}
                      />
                    </Box>
                  }
                />
              </ListItem>
              <ListItem
                button={true}
                component={NavLink}
                to={ROUTES.ACCESSIBILITY}
              >
                <ListItemText primary="Accessibility" />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  </React.Fragment>
);

export default withTheme(AppBarComponent);
